import {CookieStorage} from "@/composables/tools/cookie-tools";
import {getCookieDomain, getDomain} from "@/composables/tools/location-tools";


export const mainStorage = new CookieStorage(8, getCookieDomain(getDomain(window.location.hostname, 2)));

